import { Pagination } from "@mui/material";
import CustomButton from "../../../Components/Atoms/CustomButton";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const ImportExcelErrors = ({ handleClose }) => {
  const { postExcelVisitorLogResponse } = useSelector(
    (state) => state.visitorLogReducer
  );

  const [errorData, setErrorData] = useState([]);

  useEffect(() => {
    if (postExcelVisitorLogResponse) {
      if (!postExcelVisitorLogResponse.success) {
        setErrorData(postExcelVisitorLogResponse.data);
      }
    }
  }, [postExcelVisitorLogResponse]);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const totalPages = Math.ceil(errorData.length / itemsPerPage);

  const paginatedData = errorData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <>
      <div className="tblWrpr">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>SI.NO</th>
                <th>ROW NO</th>
                <th>REMARKS</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item, index) => (
                <tr key={item.id}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                  <td>{`#${item?.row}`}</td>
                  <td>{item?.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="d-flex-juscon-sb-align-center mt-5 mb-3">
          <div></div>
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="primary"
            size="small"
            variant="outlined"
            shape="rounded"
          />
        </div>
      </div>

      <div className="btnActnBar">
        <CustomButton
          label={"Close"}
          btnType="secondary"
          onClick={handleClose}
          action={"CANCEL"}
        />
      </div>
    </>
  );
};
export default ImportExcelErrors;
